import { isDefined } from "../utils/isDefined";
import useAuthenticatedFetch from "./common/useAuthenticatedFetch";
import { ApiResponse } from "./models/ApiResponse";
import { AvailablePeriod, ISO14064AuditData } from "./models/AuditReadiness";

export type useAuditReadinessReturn = {
    auditReadinessData?: ISO14064AuditData;
    isLoading: boolean;
};

export const useAuditReadiness = (
    year1?: number,
    quarter1?: number,
    year2?: number,
    quarter2?: number
): useAuditReadinessReturn => {
    const year2QueryParam = !year2 ? "" : `&year2=${year2}`;
    const quarter2QueryParam = !quarter2 ? "" : `&quarter2=${quarter2}`;

    const path =
        "api/audit-readiness/iso14064?" +
        `year1=${year1}` +
        `&quarter1=${quarter1}` +
        year2QueryParam +
        quarter2QueryParam;

    const { response, isLoading } = useAuthenticatedFetch<
        ApiResponse<ISO14064AuditData>
    >(path, !isDefined(year1) && !isDefined(quarter1));

    return {
        auditReadinessData: response?.content,
        isLoading,
    };
};

export const useAvailableAuditPeriods = () => {
    const { response, isLoading } = useAuthenticatedFetch<
        ApiResponse<AvailablePeriod[]>
    >("api/audit-readiness-periods?auditType=iso14064");

    return {
        availablePeriods: response?.content ?? [],
        isLoading,
    };
};
